import { selectFromOrganizationOptimizationPreferencesDto } from '../../models';

export default selectFromOrganizationOptimizationPreferencesDto()
  .projectId
  .userId
  .squashDuration
  .transportationMode
  .minimizeRoutes
  .swapRoutes
  .walkingDeliverySolver
  .gaSolver
  .excludeTolls
  .flexibleStartTime
  .timeOfDayEta
  .excludeFerry
  .timeBalance
  .visitBalance
  .defaultOrderDuration
  .organizationId
  .createdAt
  .updatedAt
  .allowCapacityOverload
  .allowShiftViolation
  .allowTimeWindowViolation
  .finishWithinTimeWindow
  .toString();
